import { Component, EventEmitter, Output } from '@angular/core';
import { LoginService } from 'src/app/login/login.service';
import { HttpService } from 'src/app/modules/core/http/http.service';

@Component({
  selector: 'app-top-toolbar',
  templateUrl: './top-toolbar.component.html',
  styleUrls: ['./top-toolbar.component.css']
})
export class TopToolbarComponent {

  donorName: string;
  activeSubmenu: any = null;

  constructor(
    private loginService: LoginService,
    private httpService: HttpService
  ) { }

  @Output() public valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.loginService.user.subscribe(res => {
      this.donorName = `${res?.responseObject?.RoledetailDTO?.roleDescription} (${res?.responseObject?.RoledetailDTO?.roleShortName})`;
    });
    this.httpService.setDataAccessDto();
  }

  logout() {
    this.valueChange.emit(true);
  }

  clickOnImg() {
    this.activeSubmenu = null;
  }
}
